import * as React from "react";
import { HudQuestsList } from "../../info/quest/list/HudQuestsList";
export var BF2HudLeft = function () { return React.createElement(HudQuestsList, null); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudLeft.tsx
// module id = 2276
// module chunks = 3